import axios from 'axios';
import { chatPath } from './routing';
import { getPath } from './helpers';

export const ChatApi = {
  sendMessage: (chatId, text, role, files, onSuccess, onError, onProgress) => {
    const formData = new FormData();
    formData.append('message[text]', text || '');
    formData.append('message[role]', role);
    files.forEach(file => formData.append('files[]', file));

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        onProgress && onProgress(percentCompleted);
      },
    };

    axios
      .post(`${chatPath(chatId)}/create_message`, formData, config)
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  getMessagesFrom: (chatId, timestamp, onSuccess, onError, search) => {
    const data = { timestamp, s: search };
    axios
      .get(getPath(`${chatPath(chatId)}/messages_from`, data), { timeout: 30000 })
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  getProjectMedia: (projectId, type, timestamp, onSuccess, onError) => {
    const data = { timestamp };
    axios
      .get(getPath(`/chats/${projectId}/${type}`, data), { timeout: 30000 })
      .then(response => {
        onSuccess({ data: response.data.data || response.data.links });
      })
      .catch(onError);
  },

  getAllDocsMedia: ({ projectId, ...rest }, onSuccess, onError) => {
    console.log(rest);
    axios
      .get(getPath(`/chats/${projectId}/all_docs_media`, { ...rest }), { timeout: 30000 })
      .then(response => {
        onSuccess({ data: response.data.data || response.data.links });
      })
      .catch(onError);
  },

  getMessagesTo: ({ chatId, timestamp, ...rest }, onSuccess, onError) => {
    axios
      .get(getPath(`${chatPath(chatId)}/messages_to`, { timestamp, ...rest }), { timeout: 30000 })
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  readMessages: (chatId, messageIds, onSuccess, onError) => {
    const config = {
      headers: { 'Content-Type': 'application/json' },
    };
    axios
      .post(`${chatPath(chatId)}/read_messages`, { ids: messageIds }, config)
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },
};

export default ChatApi;



// WEBPACK FOOTER //
// ./app/javascript/design/api/chat-api.js